import type { Dispatch, SetStateAction } from 'react';
import type React from 'react';
import { useEffect, useRef } from 'react';

import { Heading } from '@zillow/constellation-10';

import PeopleAndApplicantInformation from './PeopleAndApplicantInformation';
import { CosmosTenantSection } from '../../../models';
import { useCosmosValues } from '../../../contexts/CosmosValuesContext';
import { useSectionContext } from '../../../contexts/SectionContext';

type Props = {
  setHasError: Dispatch<SetStateAction<boolean>>;
};

export const MAX_TENANTS = 8;

function TenantInformation_cosmos({ setHasError }: Props) {
  const { cosmosValues } = useCosmosValues();
  const { section: contextSection, setSection, setSectionValues } = useSectionContext();
  const section = contextSection as CosmosTenantSection;
  const hasInitializedRef = useRef(false);

  useEffect(() => {
    if (cosmosValues && !hasInitializedRef.current) {
      const initialSection = new CosmosTenantSection(cosmosValues);
      setSection(initialSection);
      hasInitializedRef.current = true;
    }
  }, [cosmosValues, setSection]);

  if (section == null) {
    return null;
  }

  return (
    <>
      <Heading
        level={2}
        css={{
          marginBottom: 'layout.tighter',
          textStyle:
            'responsive.heading-sm' /* eslint-disable-line c11nLint/no-unknown-token -- valid textStyle; rule can't check textStyle (JSINFRA-3580) */,
        }}
      >
        Tell us about your tenants
      </Heading>
      <PeopleAndApplicantInformation
        isOptional={false}
        maximumPeople={MAX_TENANTS}
        setSectionValues={setSectionValues}
        setSection={setSection}
        section={section}
        initialPeople={0}
        setHasError={setHasError}
      />
    </>
  );
}

TenantInformation_cosmos.description = `Tenant Information with integration with Applications for Cosmos`;

export default TenantInformation_cosmos;
